<template>
  <section class="home">
    <div class="center">
      <h2>Welcome to the <strong>Item Manager</strong>.</h2>
      <h3>The fastest item manager for Destiny 2</h3>
      <a class="button shadow" @click="login">Please Authorize with Bungie.net to proceed.</a>
    </div>
    <div class="center spread shadow">
      <social-sharing url="https://itemmanager.uk/"
                      title="Item Manager for Destiny 2"
                      description="Item manager allows you transfer your items between characters with one click"
                      quote="The fastest item manager for Destiny 2."
                      hashtags="destiny,item,manager,vault"
                      twitter-user="itemmanager"
                      inline-template>
        <div>
          <network network="facebook">
            <i class="fa fa-facebook"></i> Facebook
          </network>
          <network network="googleplus">
            <i class="fa fa-google-plus"></i> Google +
          </network>
          <network network="email">
            <i class="fa fa-envelope"></i> Email
          </network>
          <network network="reddit">
            <i class="fa fa-reddit"></i> Reddit
          </network>
          <network network="twitter">
            <i class="fa fa-twitter"></i> Twitter
          </network>
          <network network="vk">
            <i class="fa fa-vk"></i> VKontakte
          </network>
          <network network="weibo">
            <i class="fa fa-weibo"></i> Weibo
          </network>
          <network network="whatsapp">
            <i class="fa fa-whatsapp"></i> Whatsapp
          </network>
        </div>
      </social-sharing>
    </div>
    <img class="screen-shot" src="../../assets/screen.png">
    <help></help>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import Panels from '@/components/Panels'
  import ItemList from '@/components/ItemList'
  import Help from '@/components/Help'
  import SocialSharing from 'vue-social-sharing'

  export default {
    name: 'content',
    data () {
      return {}
    },
    computed: {},
    methods: mapActions('auth', ['login']),
    components: {Panels, ItemList, Help, SocialSharing},
    mounted () {
      this.$root.$on('social_shares_open', (network, url) => {
        this.$ga.event({
          eventCategory: 'share',
          eventAction: 'open',
          eventLabel: network,
          eventValue: 1
        })
      })
      this.$root.$on('social_shares_close', (network, url) => {
        this.$ga.event({
          eventCategory: 'share',
          eventAction: 'close',
          eventLabel: network,
          eventValue: 1
        })
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "../../styles/settings";


  section.home {
    padding-bottom: 3rem;

    h2 {
      font-size: 2rem
    }

    h3 {
      font-size: 1.3rem;
    }

    @media #{$media-phone} {
      h2 {
        font-size: 1.5rem;
      }
      h3 {
        font-size: 1rem;
      }
    }

    .spread {
      display: block;
      background-color: darken($background, 3%);
      margin: 2rem 0;
      padding: 1rem 0;

      span {
        display: inline-block;
        margin: 0 .3rem;
        cursor: pointer;
        color: rgba(245, 245, 245, 0.5);
        transition: 0.2s color ease-in-out;
        &:hover {
          color: rgba(245, 245, 245, 0.9);
        }
      }

    }


    .button {
      display: inline-block;
      font-size: 1rem;
      background: $background;
      padding: 1rem;
      transition: all 0.2s ease-in-out;
      &:hover {
        background: lighten($background, 5%);
      }
    }

    a {
      transition: color 0.2s ease-in-out;
      color: rgba(255, 206, 31, .8);
    }

    a:hover {
      color: rgba(255, 206, 31, 1);
    }

    .center {
      text-align: center;
    }

    .loading {
      border-top: 4px solid rgba(255, 255, 255, 0);
      border-right: 4px solid rgba(255, 255, 255, .2);
      border-bottom: 4px solid rgba(255, 255, 255, .4);
      border-left: 4px solid rgba(255, 255, 255, .8);
      border-radius: 50%;
      width: 3rem;
      height: 3rem;
      animation: spin 2s linear infinite;

      display: block;
      margin: 3rem auto;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .screen-shot {
      max-width: 75%;
      margin: 2rem auto;
      display: block;
      box-shadow: 0 19px 38px rgba(0, 0, 0, 0.30), 0 15px 12px rgba(0, 0, 0, 0.22);
    }

    @media #{$media-phone} {
      .screen-shot {
        max-width: 100%;
      }

    }

  }


</style>



// WEBPACK FOOTER //
// Home.vue?5b2497ae